import { Component, OnInit } from '@angular/core';
import { DataService } from '../../utils/data.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../services/general.service';
@Component({
  selector: 'my-recibo-pago-eliminar',
  styles: [],
  templateUrl: './recibo-pago-eliminar.component.html',
  providers: [generalService]
})
export class ReciboPagoEliminarComponent implements OnInit {

  mensaje: string = '';
  constructor(
    public dataService: DataService,
    private formBuilder: FormBuilder,
    private _generalService: generalService) {   
  }

  ngOnInit() {
   
  }

  aceptar() {
    this.cancelReciboPago();
  }

  cerrarModal() {
    this.dataService.dialogRef.close();
  }

  cancelReciboPago() {
    const loacs  = sessionStorage.getItem('acslo');
    const factura = {
      loacs: loacs,
      RECEIPT_PAYMENT_ID: this.dataService.id,
      BILL_ID: this.dataService.id,
      idCompania: this.dataService.factura.idCompania,
      ORGANIZATION_ID: this.dataService.factura.idOrganizacion,
      MOTIVO: this.dataService.factura.MOTIVO,
      TOTAL: this.dataService.factura.TOTAL,
      UUID: this.dataService.factura.uuid    };
    this._generalService.metodoCallParams(factura, `RecepcionPago/cancel/`).subscribe(
          (result) => {
            this._generalService.toastCall('Se realizó la solcitud de cancelación exitosamente!');
            this.cerrarModal();
            },
          (error) => {
            console.log( error as any);
            this.cerrarModal();
          }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/recibo-pago/consultar-eliminar/recibo-pago-eliminar.component.ts